module.exports = __webpack_public_path__ + "static/img/404.a6c3231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/404.jpg
// module id = en24
// module chunks = 0